'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConfig = exports.validate = void 0;
var shared_1 = require("@cian/peperrors/shared");
function validate(candidate) {
    if (!candidate.hasOwnProperty('key')) {
        return false;
    }
    if (candidate.key === '') {
        return false;
    }
    if (!candidate.hasOwnProperty('value')) {
        return false;
    }
    return true;
}
exports.validate = validate;
function validateConfig(config) {
    if (!Array.isArray(config)) {
        throw new shared_1.ValidationError({
            message: "Config should be an array of settings. Instead loaded",
            domain: 'config.utils.validation',
            details: { payload: JSON.stringify(config, null, 2) },
        });
    }
    config.forEach(function (setting) {
        if (!validate(setting)) {
            throw new shared_1.ValidationError({
                message: "Failed to validate setting",
                domain: 'config.utils.validation',
                details: { setting: JSON.stringify(setting, null, 4) },
            });
        }
    });
}
exports.validateConfig = validateConfig;
//# sourceMappingURL=validation.js.map
